export default __webpack_public_path__ + "static/media/giriraj.59132f26.JPEG";